
import '../owner/owner.css';
import MockPanel from '../owner/widgets/mock-panel.vue';
import LandlordSettings from '../owner/widgets/landlord-settings.vue';
import PickLandlord from '../owner/widgets/pick-landlord.vue';
import DialogConfirm from '../owner/widgets/dialog-confirm.vue';
import DialogNotice from '../owner/widgets/dialog-notice.vue';
import MonthUpload from '../owner/widgets/month-upload.vue';
import VarList from '../owner/widgets/var-list.vue';
import FormulaPreview from '../owner/widgets/formula-preview.vue';
import StayReview from '../owner/widgets/stay-review.vue';
import FormulaEdit from './formula-edit.vue';

export default {
  name: 'staff-mock-host',
  components: {
    MockPanel: MockPanel,
    LandlordSettings: LandlordSettings,
    PickLandlord: PickLandlord,
    DialogConfirm: DialogConfirm,
    DialogNotice: DialogNotice,
    MonthUpload: MonthUpload,
    VarList: VarList,
    FormulaPreview: FormulaPreview,
    StayReview: StayReview,
    FormulaEdit: FormulaEdit
  },
  data: function () {
    return {
      ui: {
        settings: false,
        pick: false,
        confirm: false,
        notice: false,
        monthUpload: false,
        varList: false,
        formula: false,
        stayReview: false,
        formulaEdit: false
      },
      confirmBody: '',
      confirmHeight: 240,
      noticeTitle: '通知',
      noticeBody: '',
      mockLandlord: null,
      personalLandlord: {
        id: 1,
        account_no: 'KH-001',
        username: 'kyoran@gmail.com',
        lastname: '京蘭',
        firstname: '一太朗',
        registered_at: '2021-02-17',
        contract_start: '2021-02-17',
        account_type: 'owner',
        contract_years: 2,
        gender: '女',
        nationality: 'jp',
        phone: '075-691-8800',
        birthday: '1990-01-07',
        email: 'kyoran@gmail.com',
        postcode: '6018021',
        address: '京都市南区東九条宇賀辺町26番3',
        bank_name: '○○信用銀行',
        bank_branch: '○○支店',
        bank_account_no: '000000',
        bank_account_name: '○○太郎',
        invoice_reg_no: '648468686'
      },
      corpLandlord: {
        id: 1,
        account_no: 'KH-001',
        username: 'kyoran@gmail.com',
        company_name: '株式会社　京蘭',
        representative: '石倉　佑一',
        lastname: '京蘭',
        firstname: '一太郎',
        registered_at: '2021-02-17',
        contract_start: '2021-02-17',
        account_type: 'corporation',
        contract_years: 2,
        gender: '男',
        nationality: '',
        phone: '075-691-8800',
        birthday: '1990-01-07',
        email: 'kyoran@gmail.com',
        postcode: '6018021',
        address: '京都市南区東九条宇賀辺町26番3',
        bank_name: '○○信用銀行',
        bank_branch: '○○支店',
        bank_account_no: '000000',
        bank_account_name: '○○太郎',
        invoice_reg_no: '648468686',
        avatar_url: '/assets/img/landlord/profile-sample.jpg'
      },
      mockButtons: [
        { key: 'settings', label: '房东设定' },
        { key: 'settings-corp', label: '企业房东设定' },
        { key: 'pick', label: '选房东' },
        { key: 'change-next', label: '换房东确认（指定日）' },
        { key: 'change-21776', label: '换房东确认（今月から）' },
        { key: 'change-21796', label: '换房东确认（今月分）' },
        { key: 'template', label: '套用模板' },
        { key: 'delete', label: '删除不可恢复' },
        { key: 'lock15', label: '15日锁定' },
        { key: 'tpl-saved', label: '模板已保存' },
        { key: 'item-saved', label: '项目已保存' },
        { key: 'content-saved', label: '内容已保存' },
        { key: 'month-upload', label: '选月（上传）' },
        { key: 'upload-done', label: '上传完成' },
        { key: 'ceil', label: '繰り上げ' },
        { key: 'floor', label: '切り捨て' },
        { key: 'formula-edit', label: '编辑计算式' },
        { key: 'var-list', label: '項目代入' },
        { key: 'formula-preview', label: '式子预览' },
        { key: 'sample-card', label: '示例房东卡' },
        { key: 'stay-review', label: '试泊审批' },
        { key: 'reject-done', label: '差し戻し完成' }
      ]
    };
  },
    created: function () {
      this.mockLandlord = this.personalLandlord;
    },
    computed: {
    showMockPanel: function () {
      if (this.$route && this.$route.query && this.$route.query.mock === '1') {
        return true;
      }
      var path = (this.$route && this.$route.path) || '';
      if (path.indexOf('/pl_landlord_mock') > -1) {
        return true;
      }
      try {
        var flag = window.localStorage && localStorage.getItem('_ownerUiMock');
        if (flag && flag !== '0' && flag !== 'false') {
          return true;
        }
      } catch (e) {}
      return false;
    }
  },
  methods: {
    toastMock: function () {
      if (window.A && A.toast) A.toast('mock：未接线');
    },
    openConfirm: function (body, height) {
      this.confirmBody = body;
      this.confirmHeight = height || 240;
      this.ui.confirm = true;
    },
    openNotice: function (title, body) {
      this.noticeTitle = title;
      this.noticeBody = body;
      this.ui.notice = true;
    },
    onMockTrigger: function (key) {
      if (key === 'settings') {
        this.mockLandlord = this.personalLandlord;
        this.ui.settings = false;
        var t = this;
        this.$nextTick(function () { t.ui.settings = true; });
      } else if (key === 'settings-corp') {
        this.mockLandlord = this.corpLandlord;
        this.ui.settings = false;
        var t2 = this;
        this.$nextTick(function () { t2.ui.settings = true; });
      }
      else if (key === 'pick') this.ui.pick = true;
      else if (key === 'change-next') {
        this.openConfirm('オーナーを変更すると\n現オーナーアカウントのオーナーページにおいて\n2026年6月20日より情報が更新されなくなります。', 240);
      } else if (key === 'change-21776') {
        this.openConfirm('オーナーを変更すると\n前オーナーの\nオーナーページにおいて\n今月から情報更新が止まります。', 210);
      } else if (key === 'change-21796') {
        this.openConfirm('宿のオーナー（所有者）を変更すると\n前のオーナーアカウントの\nオーナーページにおいて\n今月分から情報が\n更新されなくなります。\n本当にオーナーを変更しますか？', 264);
      } else if (key === 'template') {
        this.openConfirm('フォーマットを適応すると\n現在の設定は上書きされます。\n本当に適応しますか？', 240);
      } else if (key === 'delete') {
        this.openConfirm('削除データの復元は不可能です\n本当に削除しますか？', 240);
      } else if (key === 'lock15') {
        this.openNotice('変更内容を更新しました', '注意！！\n毎月15日の公開後\n内容の変更できなくなります');
      } else if (key === 'tpl-saved') {
        this.openNotice('通知', '現在の編集内容を\nフォーマットとして\n保存しました');
      } else if (key === 'item-saved') {
        this.openNotice('通知', '項目の変更内容を保存しました');
      } else if (key === 'content-saved') {
        this.openNotice('通知', '変更内容を保存しました');
      } else if (key === 'month-upload') this.ui.monthUpload = true;
      else if (key === 'upload-done') this.openNotice('通知', 'アップロードが完了しました');
      else if (key === 'ceil') this.openConfirm('小数点以下を繰り上げました', 240);
      else if (key === 'floor') this.openConfirm('小数点以下を切り捨てました', 240);
      else if (key === 'formula-edit') this.ui.formulaEdit = true;
      else if (key === 'var-list') this.ui.varList = true;
      else if (key === 'formula-preview') this.ui.formula = true;
      else if (key === 'sample-card') this.$eventBus.$emit('pl-mock-sample-card');
      else if (key === 'stay-review') this.ui.stayReview = true;
      else if (key === 'reject-done') this.openNotice('通知', '差し戻しを実行しました');
    }
  }
};
